import { render, staticRenderFns } from "./NewPruning.vue?vue&type=template&id=40f895aa&scoped=true&lang=html&"
import script from "./NewPruning.vue?vue&type=script&lang=js&"
export * from "./NewPruning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f895aa",
  null
  
)

export default component.exports